import { getAvatarImage } from "../utils/firebase";

import adventureMapBg    from "../assets/map/adventure-map-bg.webp";
import spellingPeakImg   from "../assets/realms/spelling-peak.webp";
import synonymSwampImg   from "../assets/realms/synonym-swamp.webp";
import meaningMtnImg     from "../assets/realms/meaning-mountain.webp";
import antonymAlpineImg  from "../assets/realms/antonym-alpine.webp";
import mathsMesaImg      from "../assets/realms/maths-mesa.webp";
import scienceSavannahImg from "../assets/realms/science-savannah.webp";
import iconSpellingImg   from "../assets/icons/icon-spelling.webp";
import iconSynonymsImg   from "../assets/icons/icon-synonyms.webp";

import maisha1 from "../assets/avatars/maisha-1.webp";
import maisha2 from "../assets/avatars/maisha-2.webp";
import maisha3 from "../assets/avatars/maisha-3.webp";
import maisha4 from "../assets/avatars/maisha-4.webp";
import aariv1  from "../assets/avatars/aariv-1.webp";
import aariv2  from "../assets/avatars/aariv-2.webp";
import aariv3  from "../assets/avatars/aariv-3.webp";
import aariv4  from "../assets/avatars/aariv-4.webp";

const AVATAR_MAP = {
  "maisha-1": maisha1, "maisha-2": maisha2, "maisha-3": maisha3, "maisha-4": maisha4,
  "aariv-1":  aariv1,  "aariv-2":  aariv2,  "aariv-3":  aariv3,  "aariv-4":  aariv4,
};

export function AdventureHomeLayout({
  user, data,
  onStartTest, onStartMeaningTest, onStartSynonymTest, onStartAntonymTest,
  onShowProfile,
}) {
  const myPoints   = data.points?.[user.id] || 0;
  const streak     = data.streaks?.[user.id] || 0;
  const avatarSlug = getAvatarImage(user);
  const avatarSrc  = AVATAR_MAP[avatarSlug] || maisha1;
  const xpPct      = Math.min(100, Math.round((myPoints / 1000) * 100));

  const mySessions = data.sessions.filter(s => s.userId === user.id);
  const today      = new Date().toDateString();
  const doneSpellingToday = mySessions.filter(s => s.type !== "meaning" && s.type !== "synonym" && s.type !== "antonym").some(s => new Date(s.date).toDateString() === today);
  const doneMeaningToday  = mySessions.filter(s => s.type === "meaning").some(s => new Date(s.date).toDateString() === today);
  const doneSynonymToday  = mySessions.filter(s => s.type === "synonym").some(s => new Date(s.date).toDateString() === today);
  const doneAntonymToday  = mySessions.filter(s => s.type === "antonym").some(s => new Date(s.date).toDateString() === today);

  const HOTSPOTS = [
    { id: "spelling", label: "Spelling Peak",    sub: doneSpellingToday ? "✓ Done" : "Ready!", img: spellingPeakImg,    left: "18%", top: "22%", onClick: onStartTest,        locked: false, active: true  },
    { id: "synonym",  label: "Synonym Swamp",    sub: doneSynonymToday  ? "✓ Done" : "Ready!", img: synonymSwampImg,    left: "34%", top: "55%", onClick: onStartSynonymTest, locked: false, active: false },
    { id: "meaning",  label: "Meaning Mtn",      sub: doneMeaningToday  ? "✓ Done" : "Ready!", img: meaningMtnImg,      left: "50%", top: "18%", onClick: onStartMeaningTest, locked: false, active: false },
    { id: "antonym",  label: "Antonym Alpine",   sub: doneAntonymToday  ? "✓ Done" : "Ready!", img: antonymAlpineImg,   left: "55%", top: "55%", onClick: onStartAntonymTest, locked: false, active: false },
    { id: "maths",    label: "Maths Mesa",        sub: "Coming Soon",                           img: mathsMesaImg,       left: "76%", top: "12%", onClick: null,               locked: true,  active: false },
    { id: "science",  label: "Science Savannah",  sub: "Coming Soon",                           img: scienceSavannahImg, left: "80%", top: "22%", onClick: null,               locked: true,  active: false },
  ];

  const QUESTS = [
    { icon: iconSpellingImg, emoji: null, label: "Complete Spelling Test",       reward: 50,  done: doneSpellingToday, onClick: onStartTest        },
    { icon: iconSynonymsImg, emoji: null, label: "Win 5 Synonym Rounds",         reward: 30,  done: doneSynonymToday,  onClick: onStartSynonymTest  },
    { icon: null,            emoji: "🔥", label: `Keep your streak (${streak} days)`, reward: 100, done: false, onClick: null },
  ];

  return (
    <div style={{
      margin: "0 -1.5rem",
      display: "flex",
      flexDirection: "column",
      minHeight: "75vh",
      background: "#0a0f1a",
      color: "#fff",
      fontFamily: "'Nunito', sans-serif",
      overflowX: "hidden",
    }}>
      {/* ── Player Bar ── */}
      <div style={{
        display: "flex", alignItems: "center", gap: ".75rem",
        padding: ".75rem 1.25rem",
        background: "rgba(0,0,0,.5)",
        borderBottom: "1px solid rgba(255,255,255,.08)",
        flexShrink: 0,
      }}>
        {/* Tappable: avatar + name + XP */}
        <div
          onClick={() => onShowProfile?.()}
          style={{ display: "flex", alignItems: "center", gap: ".75rem", flex: 1, minWidth: 0, cursor: "pointer" }}
        >
          <img
            src={avatarSrc}
            alt={user.name}
            style={{ width: 42, height: 42, borderRadius: "50%", border: "2px solid #f59e0b", objectFit: "cover", flexShrink: 0 }}
          />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 900, fontSize: ".95rem", color: "#fff", letterSpacing: ".01em" }}>{user.name}</div>
            <div style={{ fontSize: ".7rem", color: "rgba(255,255,255,.5)", marginBottom: ".25rem" }}>
              {user.level || "Level 1 · Spell Seeker"}
            </div>
            <div style={{ background: "rgba(255,255,255,.15)", borderRadius: 999, height: 6, overflow: "hidden" }}>
              <div style={{
                height: "100%",
                background: "linear-gradient(90deg,#f59e0b,#fbbf24)",
                borderRadius: 999,
                width: `${xpPct}%`,
                transition: "width .5s",
              }} />
            </div>
          </div>
          <span style={{ fontSize: ".85rem", color: "rgba(255,255,255,.45)", flexShrink: 0 }}>⚙️</span>
        </div>
        <div style={{
          display: "flex", alignItems: "center", gap: ".3rem",
          background: "rgba(245,158,11,.15)",
          border: "1px solid rgba(245,158,11,.3)",
          borderRadius: 999,
          padding: ".3rem .75rem",
          flexShrink: 0,
        }}>
          <span style={{ fontSize: "1rem" }}>🪙</span>
          <span style={{ fontWeight: 800, fontSize: ".9rem", color: "#fbbf24" }}>{myPoints}</span>
        </div>
      </div>

      {/* ── Map Area ── */}
      <div style={{ flex: 1, position: "relative", overflow: "hidden", minHeight: 320 }}>
        <img
          src={adventureMapBg}
          alt=""
          style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "left top", display: "block" }}
        />
        {HOTSPOTS.map(spot => (
          <div
            key={spot.id}
            onClick={() => !spot.locked && spot.onClick && spot.onClick()}
            style={{
              position: "absolute",
              left: spot.left,
              top: spot.top,
              transform: "translate(-50%, -50%)",
              width: 82,
              textAlign: "center",
              cursor: spot.locked ? "default" : "pointer",
              background: "rgba(0,0,0,.65)",
              backdropFilter: "blur(6px)",
              borderRadius: 12,
              border: spot.active ? "1.5px solid #f59e0b" : "1px solid rgba(255,255,255,.15)",
              padding: ".4rem .35rem .5rem",
              transition: "transform .15s",
              userSelect: "none",
            }}
          >
            {spot.active && (
              <div style={{
                position: "absolute", top: -8, right: -8,
                background: "#f59e0b", color: "#000",
                fontSize: ".55rem", fontWeight: 900,
                borderRadius: 999, padding: ".15rem .4rem",
                letterSpacing: ".03em", zIndex: 1,
              }}>ACTIVE</div>
            )}
            {spot.locked && (
              <div style={{
                position: "absolute", inset: 0,
                background: "rgba(0,0,0,.55)",
                borderRadius: 12,
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: "1.25rem", zIndex: 1,
              }}>🔒</div>
            )}
            <img
              src={spot.img}
              alt={spot.label}
              style={{ width: "100%", height: 46, objectFit: "cover", borderRadius: 8, display: "block", marginBottom: ".3rem" }}
            />
            <div style={{ fontSize: ".65rem", fontWeight: 800, color: "#fff", lineHeight: 1.2, marginBottom: ".15rem" }}>{spot.label}</div>
            <div style={{ fontSize: ".58rem", color: "rgba(255,255,255,.55)", fontWeight: 600 }}>{spot.sub}</div>
          </div>
        ))}
      </div>

      {/* ── Quest Panel ── */}
      <div style={{
        background: "rgba(0,0,0,.7)",
        backdropFilter: "blur(8px)",
        padding: ".75rem 1.25rem",
        borderTop: "1px solid rgba(255,255,255,.08)",
        minHeight: 120,
        flexShrink: 0,
      }}>
        <div style={{ fontWeight: 900, fontSize: ".82rem", color: "#fbbf24", marginBottom: ".6rem", letterSpacing: ".03em" }}>
          ⚔️ Daily Quests
        </div>
        {QUESTS.map((q, i) => (
          <div
            key={i}
            onClick={() => !q.done && q.onClick && q.onClick()}
            style={{
              display: "flex", alignItems: "center", gap: ".65rem",
              padding: ".35rem 0",
              cursor: q.done || !q.onClick ? "default" : "pointer",
              opacity: q.done ? 0.45 : 1,
            }}
          >
            {q.icon
              ? <img src={q.icon} alt="" style={{ width: 22, height: 22, borderRadius: 6, objectFit: "cover", flexShrink: 0 }} />
              : <span style={{ fontSize: "1.1rem", width: 22, textAlign: "center", flexShrink: 0 }}>{q.emoji}</span>
            }
            <span style={{ flex: 1, fontSize: ".78rem", fontWeight: 700, color: q.done ? "rgba(255,255,255,.4)" : "#fff" }}>
              {q.done ? "✓ " : ""}{q.label}
            </span>
            <span style={{ fontSize: ".75rem", fontWeight: 800, color: "#fbbf24", flexShrink: 0 }}>+{q.reward} 🪙</span>
          </div>
        ))}
      </div>
    </div>
  );
}
